export const iNoLongerLyrics = [
  { text: "Iiiiiii", start: 17, end: 20.8 },
  { text: "I", start: 20.8, end: 22.2 },
  { text: "I", start: 22.2, end: 23.4 },
  { text: "I", start: 23.4, end: 24 },
  { text: "Mmm mmm mmm mmm mmm mmm mmm", start: 24, end: 26 },
  { text: "I", start: 26, end: 26.5 },
  { text: "Mmm mmm mmm mmm mmm mmm mmm", start: 26.5, end: 35 },
  { text: "Yep", start: 35.6, end: 36 },
  { text: "For five nights and five days I would hide", start: 36, end: 39.6 },
  { text: "Letting my emotions take me for a ride", start: 39.6, end: 42.17 },
  { text: "Been yearning for your validation", start: 42.17, end: 44 },
  { text: "False affirmations", start: 44, end: 45.8 },
  { text: "Some I shouldn't be saying", start: 45.8, end: 47.9 },
  { text: "But I had to break I had to break the mold", start: 47.9, end: 51.06 },
  { text: "In this one that you've built for me I've no room to grow", start: 51.06, end: 54.2 },
  { text: "Why bide, bide", start: 54.2, end: 57.5 },
  { text: "Myyyyy time", start: 57.5, end: 60.3 },
  { text: "Mmm", start: 60.3, end: 61 },
  { text: "And these tears I've cried for ya couldn't run your bath water no matter how hard I cry", start: 61, end: 65.7 },
  { text: "Wooo", start: 65.7, end: 68 },
  { text: "Mmm I've cried", start: 68, end: 69.7 },
  { text: "Nearly lost my mind", start: 69.7, end: 72 },
  { text: "Now I'm prepared", start: 72, end: 74.9 },
  { text: "None shall be spared", start: 74.9, end: 80 },
  { text: "I don't wanna play fair", start: 80, end: 83 },
  { text: "Hey", start: 83, end: 84 },
  { text: "I no longer try to control how you think of me", start: 84, end: 90.7 },
  { text: "Whether I'm alive or I'm dead", start: 90.7, end: 93.2 },
  { text: "And I say it will my chest", start: 93.2, end: 95.5 },
  { text: "I no longer try to control how you think of me", start: 95.5, end: 103.85 },
  { text: "Meeeeeee", start: 103.85, end: 108 },
  { text: "Member you said to put you on", start: 108, end: 109.8 },
  { text: "I bet you didn't think that I would put you in a song", start: 109.8, end: 112.5 },
  { text: "Don't worry cause this ain't about me tryna prove you wrong", start: 112.5, end: 116 },
  { text: "I made the right decision cause you don't know right from wrong I mean how", start: 116, end: 119 },
  { text: "How many lessons", start: 119, end: 121 },
  { text: "Do you need to learn", start: 121, end: 122.5 },
  { text: "The car you drive means nothing when the bridges are burned", start: 122.5, end: 125.5 },
  { text: "But still", start: 125.5, end: 126 },
  { text: "You drive yourself over the edge", start: 126, end: 129.11 },
  { text: "And the moment someone finds you there", start: 129.11, end: 131.5 },
  { text: "Mmm", start: 131.5, end: 132 },
  { text: "That's when you lie, lie", start: 132, end: 133.5 },
  { text: "Cheat, cheat", start: 133.5, end: 134 },
  { text: "Say what you will", start: 134, end: 136 },
  { text: "And you will", start: 136, end: 137 },
  { text: "I've tried to fit in", start: 137, end: 138.5 },
  { text: "In pots you've pissed in", start: 138.5, end: 139.5 },
  { text: "No I don't fit in", start: 139.5, end: 140.8 },
  { text: "And now the pots you've pissed in", start: 140.8, end: 142 },
  { text: "You sit in, you sit in", start: 142, end: 143.7 },
  { text: "Wallow in blame", start: 143.7, end: 145 },
  { text: "Mope and complain", start: 145, end: 146 },
  { text: "Pull me back and say you changed", start: 146, end: 147 },
  { text: "You're far too shattered for a glazier to pane", start: 147, end: 149.7 },
  { text: "You sing the same damn songs and on deaf ears they fall", start: 149.7, end: 155.6 },
  { text: "It's not a broken record it's a fucked up song that keeps playing", start: 155.6, end: 159 },
  { text: "You sure love to play it", start: 159, end: 161.8 },
  { text: "Hoping the message will change", start: 161.8, end: 164 },
  { text: "I was enamored by your disdain", start: 164, end: 167 },
  { text: "I was too foolish, not naive but insane", start: 167, end: 170 },
  { text: "Unsuccessful in the business keeping you entertained", start: 170, end: 173 },
  { text: "Every pattern of disrespect that I let slide", start: 173, end: 176 },
  { text: "Was just a means for me to try to pacify", start: 176, end: 179.1 },
  { text: "Why should I be", start: 179.1, end: 180.4 },
  { text: "Chasing validation or adoration instead of raising", start: 180.4, end: 184.8 },
  { text: "My inner child", start: 184.8, end: 187 },
  { text: "But the roots were left to die", start: 187, end: 191.2 },
  { text: "I cut the cord this is imperative", start: 191.2, end: 194.6 },
  { text: "I'm at peace with not controlling every narrative", start: 194.6, end: 197 },
  { text: "Now that I've finally found the value in myself", start: 197, end: 201 },
  { text: "Your opinion of me doesn't help", start: 201, end: 204 },
  { text: "I no longer try to control what you think of me", start: 204, end: 212.2 },
  { text: "I no longer try to control what you think of me", start: 212.2, end: 224.5 },
  { text: "Our souls can no longer collide", start: 224.5, end: 230.5 },
  { text: "So I bid a due, goodbye", start: 230.5, end: 233.9 },
  { text: "Our paths can longer collide", start: 233.9, end: 236.8 },
  { text: "So I bid a due", start: 236.8, end: 238 },
  { text: "Yeah this is my goodbye", start: 238, end: 243.9 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
